module.exports = __webpack_public_path__ + "img/carDriving.14954dcd.png";